var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../strings/i18n/i18n';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import query from 'syf-component-library/const/mediaQueries';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import theme from '../../../theme';
import TableHeader from './TableHeader';
var TableHeaderRowWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  padding: 10px ", "px 10px 72px;\n\n  @media ", " {\n    justify-content: flex-start;\n    padding-left: 83px;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  padding: 10px ", "px 10px 72px;\n\n  @media ", " {\n    justify-content: flex-start;\n    padding-left: 83px;\n  }\n"])), theme.colors.lightGrey, spacing.base, query.greaterThanMedium);
var TableHeaderRow = function (_a) {
    var sorters = _a.sorters, onToggleSort = _a.onToggleSort;
    var isGreaterThanTablet = !useWindowSize().isLessThanTablet;
    return (_jsxs(TableHeaderRowWrapper, { children: [_jsx(TableHeader, { "$name": "postedDate", text: t('sorter.postedDate'), sorting: {
                    onToggle: function () { return onToggleSort('postedDate'); },
                    order: sorters.postedDate
                } }), isGreaterThanTablet && (_jsxs(_Fragment, { children: [_jsx(TableHeader, { "$name": "claimId", text: t('sorter.disputeId'), sorting: {
                            onToggle: function () { return onToggleSort('claimId'); },
                            order: sorters.claimId
                        } }), _jsx(TableHeader, { "$name": "description", text: t('sorter.description') })] })), _jsx(TableHeader, { "$name": "amount", text: t('sorter.amount'), sorting: {
                    onToggle: function () { return onToggleSort('amount'); },
                    order: sorters.amount
                } })] }));
};
export default TableHeaderRow;
var templateObject_1;
//# sourceMappingURL=TableHeaderRow.js.map